function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { IAvailabilityActions, TermsStrings } from '@shared/Models';
import { cloneDeep } from 'lodash-es';
import { logError } from '@shared/utils/httpClientUtil';
import { OfferType } from '@shared/utils/constants';
export var OS = /*#__PURE__*/ function(OS) {
    OS[OS["Windows"] = 1] = "Windows";
    OS[OS["Linux"] = 2] = "Linux";
    return OS;
}({});
const MONTH_UNIT = 'Month';
const YEAR_UNIT = 'Year';
const MONTH_THERM_UNIT = 'P1M';
const YEAR_THERM_UNIT = 'P1Y';
const isUnitEqual = (term, termPrice, mightContainMultiyearTerms)=>{
    if (mightContainMultiyearTerms) {
        if (!(term === null || term === void 0 ? void 0 : term.termId) || !(termPrice === null || termPrice === void 0 ? void 0 : termPrice.termId)) {
            return false;
        }
        return term.termId === termPrice.termId;
    }
    return term && termPrice && (term.termUnits === MONTH_THERM_UNIT && termPrice.unit === MONTH_UNIT || term.termUnits === YEAR_THERM_UNIT && termPrice.unit === YEAR_UNIT);
};
const filterDecreasePrices = (sku, hasMonthlyPriceIncrease, hasYearlyPriceIncrease, hasMeterPriceIncrease)=>{
    if (!hasMeterPriceIncrease) {
        const increaseTermPrices = sku.termPrices.filter((termPrice)=>termPrice.unit === MONTH_UNIT && hasMonthlyPriceIncrease || termPrice.unit === YEAR_UNIT && hasYearlyPriceIncrease);
        if (increaseTermPrices) {
            sku.termPrices = increaseTermPrices;
        } else {
            sku = null;
        }
    }
    return sku;
};
const updateTermPrices = (futurePlan, sku)=>{
    let hasMonthlyPriceIncrease = false;
    let hasYearlyPriceIncrease = false;
    let hasMeterPriceIncrease = false;
    sku.startDate = futurePlan.availabilities[0].startDate;
    const mightContainMultiyearTerms = sku.offerType === OfferType.SaaSApp;
    const increasedTermIds = [];
    futurePlan.availabilities.forEach((futureAvailability)=>{
        // Update termPrice value
        const { actions } = futureAvailability;
        if (actions.includes(IAvailabilityActions.Purchase) && actions.includes(IAvailabilityActions.Browse)) {
            futureAvailability.terms.forEach((futureTerm)=>{
                var _term_billingPlan, _futureTerm_billingPlan;
                const term = sku.termPrices.find((termPrice)=>isUnitEqual(futureTerm, termPrice, mightContainMultiyearTerms));
                if (!term) {
                    return;
                }
                const wasPriceIncreased = futureTerm.price.listPrice > term.value;
                if (wasPriceIncreased) {
                    if (mightContainMultiyearTerms) {
                        increasedTermIds.push(term.termId);
                    } else {
                        hasMonthlyPriceIncrease = hasMonthlyPriceIncrease || term.unit === TermsStrings.MonthString;
                        hasYearlyPriceIncrease = hasYearlyPriceIncrease || term.unit === TermsStrings.YearString;
                    }
                }
                term.value = futureTerm.price.listPrice;
                if (((_term_billingPlan = term.billingPlan) === null || _term_billingPlan === void 0 ? void 0 : _term_billingPlan.price) && ((_futureTerm_billingPlan = futureTerm.billingPlan) === null || _futureTerm_billingPlan === void 0 ? void 0 : _futureTerm_billingPlan.price)) {
                    term.billingPlan.price = _object_spread({}, futureTerm.billingPlan.price);
                }
            });
        }
        // Update customMeter price
        if (actions.includes(IAvailabilityActions.Consume) && actions.includes(IAvailabilityActions.Browse)) {
            sku.termPrices.forEach((termPrice)=>{
                const meter = termPrice.customMeter.find((customMeter)=>customMeter.availabilityId === futureAvailability.currentAvailabilityId);
                if (meter) {
                    if (futureAvailability.meter.price.listPrice > meter.rate) {
                        hasMeterPriceIncrease = true;
                    }
                    meter.rate = futureAvailability.meter.price.listPrice;
                }
            });
        }
    });
    if (mightContainMultiyearTerms) {
        if (!hasMeterPriceIncrease) {
            sku.termPrices = sku.termPrices.filter((termPrice)=>increasedTermIds.includes(termPrice.termId));
        }
        return sku;
    } else {
        return filterDecreasePrices(sku, hasMonthlyPriceIncrease, hasYearlyPriceIncrease, hasMeterPriceIncrease);
    }
};
const updateThirdPartyPricing = (futurePlan, sku)=>{
    const futurePricePerCore = {};
    sku.startDate = futurePlan.availabilities[0].startDate;
    futurePlan.availabilities.forEach((futureAvailability)=>{
        if (futureAvailability.meter && sku.thirdPartyPricing.pricePerCore) {
            const currentMeter = sku.thirdPartyPricing.pricePerCore[futureAvailability.meter.meterId];
            if (currentMeter && currentMeter.availabilityId === futureAvailability.currentAvailabilityId && futureAvailability.meter.price.listPrice > currentMeter.value) {
                currentMeter.value = futureAvailability.meter.price.listPrice;
                futurePricePerCore[futureAvailability.meter.meterId] = currentMeter;
            }
        }
    });
    sku.thirdPartyPricing.pricePerCore = futurePricePerCore;
    return Object.keys(futurePricePerCore).length ? sku : null;
};
const getFuturePricesSkus = (futurePlans, currentSkus)=>{
    const futureSkus = [];
    if (futurePlans && currentSkus) {
        futurePlans.forEach((futurePlan)=>{
            var _futurePlan_availabilities;
            const currentSku = currentSkus.find((skus)=>skus.id === futurePlan.planId);
            if (!currentSku) {
                logError(`getFuturePricesSkus failed to find current sku: ${futurePlan.planId}`);
            } else if (!((_futurePlan_availabilities = futurePlan.availabilities) === null || _futurePlan_availabilities === void 0 ? void 0 : _futurePlan_availabilities.length)) {
                logError(`getFuturePricesSkus futurePlan: ${futurePlan.planId} - not contains availabilities`);
            } else {
                let futureSku = cloneDeep(currentSku);
                if (futureSku.termPrices) {
                    futureSku = updateTermPrices(futurePlan, futureSku);
                }
                if (futureSku.thirdPartyPricing) {
                    futureSku = updateThirdPartyPricing(futurePlan, futureSku);
                }
                if (futureSku) {
                    futureSkus.push(futureSku);
                }
            }
        });
    }
    return futureSkus;
};
export const getFuturePricesInformation = (futurePrices, currentPrices)=>{
    if (futurePrices && currentPrices) {
        const futureSkus = getFuturePricesSkus(futurePrices.plans, currentPrices.skus);
        if (futureSkus === null || futureSkus === void 0 ? void 0 : futureSkus.length) {
            return {
                billingRegion: currentPrices.billingRegion,
                skus: futureSkus
            };
        }
    }
    return null;
};
export const getUTCDateString = (startDateUtcInMinutes, context)=>{
    return `${context.locDateString(startDateUtcInMinutes * 60000, {
        timeZone: 'UTC'
    })} (UTC)`;
};
